import { LoggerScope } from '~/main/utils/logger';
import Logger from '~/renderer/utils/logger';

export const PAGE_BREAK_REGEX = /([^>|{}}]+?){[^{]*?page-break-(after|before):\s?always/g;

function getVerticalMargin(document: Document, node: Element): number {
  const styles = document.defaultView?.getComputedStyle(node);

  return styles ? (parseFloat(styles.marginTop) || 0) + (parseFloat(styles.marginBottom) || 0) : 0;
}

export const cleanSelector = (selector: string) =>
  selector
    .replace(/[\r\n]/g, '')
    .replace(/\s+/g, ' ')
    .trim();

export const partialCuts = (iframe: HTMLIFrameElement | null): number[] => {
  if (!iframe || !iframe.contentWindow) {
    throw new Error('Missing content window');
  }
  const { document } = iframe.contentWindow;
  const cuts: number[] = [];

  // Only getting the partial cuts from the head <style> tag
  document.head.querySelectorAll('style').forEach(styleTag =>
    styleTag.innerHTML.replace(
      PAGE_BREAK_REGEX,
      (match, selector: string, position: 'before' | 'after') => {
        const cleanedSelector = cleanSelector(selector);

        try {
          document.querySelectorAll(cleanedSelector).forEach(node => {
            const { top, height } = node.getBoundingClientRect();
            const absoluteHeight = height + getVerticalMargin(document, node);

            // @NOTE Ignore a partial cut if it's the last child of the document
            // or if the height of the element is greater or equal to the document height
            if (
              !absoluteHeight ||
              document.body.lastChild === node ||
              document.body.offsetHeight <= absoluteHeight
            )
              return;

            const cutHeight = Math.ceil(top + (position === 'before' ? 0 : absoluteHeight)) * 2;

            cuts.push(cutHeight);
          });
        } catch (err) {
          Logger({ scope: LoggerScope.HUB }).error({
            err,
          });
        }
        return match;
      },
    ),
  );

  return cuts;
};
